/* eslint-disable max-len */
import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { string, shape, object } from "prop-types";
import { LazyCollection, LazyLoadImages } from "@quintype/components";

import { getCollectionTemplate } from "../../get-collection-template";

import { SubSectionPage } from "../sub-section-page";
import MobileCollection from "../../collection-templates/mobile-collection";

import Bredcrum from "../../story-templates/story-header/bredcrums";
import NewIframeTopBanner from "../../atoms/new-iframe-top-banner";

import TaboolaScript from "../../ads/taboola-ad/load-taboola-ad";
import TaboolaAd from "../../ads/taboola-ad";
import EPaperBanner from "../../atoms/epaper-banner";

import "./section-page.m.css";

const SectionPage = ({ data }) => {
  if (!data?.collection?.items?.length) return null;

  const { collection } = data;
  const stories = collection?.items?.filter((item) => item?.type === "story").slice(0, 6);

  const pageTitle = collection?.name;

  const filterCollections = collection?.items?.filter((i) => i.items && i.items.length) || [];

  const collection1 = { ...collection };
  collection1.items = filterCollections.length > 0 ? [filterCollections[0]] : [];

  const remainingCollection = { ...collection };
  remainingCollection.items = filterCollections.length > 1 ? filterCollections.slice(1) : [];

  const initialPath = typeof window !== "undefined" ? window.location.pathname : "";

  const isCustomHeaderPage = collection?.metadata?.["custom-header"] === "cok2025" || collection?.metadata?.["custom-header"] === "festivals";
  const bannerClassName = isCustomHeaderPage ? "no-margin-top" : "";

  const customHeader = collection?.metadata?.["custom-header"];
  const hideBannerForCustomHeader = customHeader === "Canara-Robeco";

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const topBannerConfig = qtState?.data?.frontendConfig?.topBannerConfig;

  const normalizePath = (path = "") => {
    return path.split("?")[0].replace(/\/+$/, "") || "/";
  };

  const avoidUrls = (
    Array.isArray(topBannerConfig?.avoidUrl)
      ? topBannerConfig.avoidUrl
      : typeof topBannerConfig?.avoidUrl === "string"
        ? [topBannerConfig.avoidUrl]
        : []
  ).map(normalizePath);

  const currentPath = normalizePath(qtState?.currentPath);

  const avoidTopBanner = avoidUrls.includes(currentPath);

  // If stories exist, render SubSectionPage with banner at top level
  if (stories?.length) {
    return (
      <>
        {!hideBannerForCustomHeader && <EPaperBanner utmMedium="topbanner" className={bannerClassName} />}
        <SubSectionPage data={data} hideBanner={true} />
        <SubSectionPage data={data} avoidTopBanner={avoidTopBanner} />
      </>
    );
  }

  return (
    <>
      {!hideBannerForCustomHeader && <EPaperBanner utmMedium="top_banner" className={bannerClassName} />}
      <div className="container" styleName="wrapper">
        {!avoidTopBanner && <NewIframeTopBanner />}
        {!hideBannerForCustomHeader && <Bredcrum initialPath={initialPath} type="section-page" />}
        {!hideBannerForCustomHeader && <TaboolaScript type="category" />}
        {!hideBannerForCustomHeader && (
          <div styleName="title">
            <h1>{pageTitle}</h1>
          </div>
        )}
        <LazyLoadImages>
          <div className="hide-mobile">
            <LazyCollection
              collection={collection1}
              collectionTemplates={getCollectionTemplate}
              lazyAfter={2}
              className="lazy-collection"
            />
          </div>
          <div className="hide-desktop">
            {collection1.items?.[0] && <MobileCollection collection={collection1.items[0]} />}
          </div>
          <LazyCollection
            collection={remainingCollection}
            collectionTemplates={getCollectionTemplate}
            lazyAfter={2}
            className="lazy-collection"
          />
        </LazyLoadImages>

        {!hideBannerForCustomHeader && (
          <TaboolaAd
            container="taboola-below-category-thumbnail--pj"
            placement="Below Category Thumbnail- PJ"
            mode="alternating-thumbnails-a"
          />
        )}
      </div>
    </>
  );
};

SectionPage.propTypes = {
  pageType: string,
  data: shape({
    collection: object,
    section: string
  })
};

export { SectionPage };
